<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {
      messageList: ["您已提交成功，我们将尽快回复您！"],
    };
  },
  methods: {
    message() {
      this.$message({
        message: this.$t("header.dialog.form.success"),
        type: "success",
        dangerouslyUseHTMLString: true,
        center: true,
        customClass: "myClass",
        duration: 3000,
      });
    },
  },
};
</script>
<style lang="scss">
.myClass {
  background: linear-gradient(0.98deg, #151c37 0.9%, #1f294d 99.24%);
  border-color: #151c37 !important;

  .el-message__content {
    color: #ffffff !important;
  }

  .el-message__icon {
    color: #13c2c2 !important;
  }
}
</style>
